export default __webpack_public_path__ + "static/gift-card-10.url-53c0876feed8dd5b2b799933d35e63f4.svg";